export const loadMore = function( button, $, cb ) {
	//console.log( button );
	const button = $(button);
	const prevButtonText = button.html();
	const loadingText = button.data( 'loading-text' );
	const ajaxurl = button.data( 'ajax-url' );
	const queryParams = button.data( 'query-params' );
	const targetContainer = button.data( 'target-container' );
	const maxPages = button.data( 'max-pages' );
	let currentPage = button.data( 'current-page' );

	button.text( loadingText );
	$.ajax({
		url: ajaxurl,
		data: {
			action: 'loadmore',
			query: queryParams,
			page: currentPage
		},
		type: "POST",
		success: ( response ) => {
			button.html( prevButtonText );
			if( response ) {
				button.data('current-page', ++currentPage);
				setData( $, response, targetContainer );
				if( currentPage >= maxPages ) button.remove();
			}else{
				button.remove();
			}
			cb();
		},
		error: ( erro1, error2, error3 ) => {
			console.error( error1, error2, error3 );
		}

	})
}


const setData = ( $, data, containerSelector ) => {
	$( containerSelector ).append( data );
}

export default loadMore;